import { Dispatch, SetStateAction, createContext } from "react";

type StateType<T> = [T, Dispatch<SetStateAction<T>>];

export interface WidgetContainerHeaderActionsProps {
  [key: string]: JSX.Element;
}

export interface WidgetContainerContextProps {
  headerActions?: StateType<WidgetContainerHeaderActionsProps>;
  currentWidgetFullscreen: boolean;
}

export const WidgetContainerContext = createContext<WidgetContainerContextProps>({
  headerActions: undefined,
  currentWidgetFullscreen: false,
});
